import { Box } from '@mui/material'
import * as React from 'react'

import { OfficeFormProps } from '../../types/ComponentProps'
import FormMessages from '../desk/FormMessages'

import OfficeFormFields from './OfficeFormFields'
import OfficeFormSubmitButton from './OfficeFormSubmitButton'

/**
 * OfficeForm - Presentation component for office creation form
 * Focuses only on form rendering and validation display
 *
 * Requirements: 1.1, 3.4, 5.1, 5.5
 */
export default function OfficeForm({
  formData,
  isSubmitting,
  isRetrying = false,
  retryCount = 0,
  validationErrors,
  successMessage,
  onSubmit,
  onChange,
  onClearMessage,
  isEditMode = false
}: OfficeFormProps) {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    onSubmit()
  }

  return (
    <Box component='form' noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
      <FormMessages
        validationErrors={validationErrors}
        successMessage={successMessage}
        onClearMessage={onClearMessage}
        isRetrying={isRetrying}
      />

      <OfficeFormFields
        formData={formData}
        onChange={onChange}
        disabled={isSubmitting || isRetrying}
      />

      <OfficeFormSubmitButton
        isSubmitting={isSubmitting}
        isRetrying={isRetrying}
        retryCount={retryCount}
        isEditMode={isEditMode}
      />
    </Box>
  )
}
